import React from 'react';
import "../../../sass/guest/duplicate-address.scss";
import {Head} from "@inertiajs/inertia-react";
import i18n from "i18next";
import AbstractSignupArtwork from "@/Components/AbstractSignupArtwork";
import ProductLogo from "@/Components/ProductLogo";
import Guest from "@/Layouts/Guest";


export default function DuplicateAddress() {
    return (
        <Guest>
            <AbstractSignupArtwork/>
            <Head title="Signup" />
            <div className="signup">
                <ProductLogo />
                <div className="row">
                    <span data-testid="duplicate_address-span-message">{i18n.t("duplicate-address")}</span>
                </div>
            </div>
        </Guest>
    );
}
